import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@driftt/tide-core';
import { Icon } from '@driftt/tide-icons'
import { createApp } from 'api/developerApi'
import { withRouter } from 'react-router-dom'
import cx from 'classnames'
import './style.css'

class HeroTextPane extends Component {

  static propTypes = {
    showErrorNotification: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  state = {
    isCreatingApp: false
  }

  createNewApp = () => {
    const onDone = (app) => {
      this.setState({ isCreatingApp: false })
      this.props.history.push(`/app/${app.id}`)
    }

    const onError = (error) => {
      this.setState({ isCreatingApp: false })
      this.props.showErrorNotification('Ooops, something went wrong. Please try again.')
    }

    const onStateSet = () => {
      createApp()
        .then(onDone)
        .catch(onError)
    }

    this.setState({ isCreatingApp: true }, onStateSet)
  }

  render() {
    const { className } = this.props
    const { isCreatingApp } = this.state

    return (
      <div className={cx('apps-hero-text-pane', className)}>
        <span className="apps-hero-text-pane-title">
          Get building with the Drift API
        </span>
        <p className="app-hero-text-pane-description">
          Everything you need to customize Drift to fit your team’s needs. Let’s do this.
        </p>
        <Button
          className="app-hero-text-pane-button"
          onClick={this.createNewApp}
          loading={isCreatingApp}
          type="primary"
          size="large">
          Create New App
        </Button>
        <a href="https://devdocs.drift.com"
          className="hero-learn-more"
          target="_blank"
          rel="noopener noreferrer">
          Learn More
          <Icon name="arrow-2-right" width="18"/>
        </a>
      </div>
    )
  }
}

export default withRouter(HeroTextPane)
